export default {
  default: 'https://www.gocanvas.com',
  style: 0,
  mask: 'Tap here...'
};